import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

interface ComponentProps {
  className: string;
  data: any; // Update this type based on your actual data structure
}

function getColors(name: string) {
  switch (name) {
    case "roadsideBreakdowns":
    case "majorRepairs":
    case "accidents":
    case "brokenVehicles":
      return {
        backgroundColor: "rgba(237, 32, 32, 0.1)",
        borderColor: "#ED2020",
        pointBackgroundColor: "#ED2020",
      };
    case "inMaintenance":
      return {
        backgroundColor: "rgba(245, 116, 0, 0.1)",
        borderColor: "#F57400",
        pointBackgroundColor: "#F57400",
      };
    case "rideInProgresss":
      return {
        backgroundColor: "rgba(44, 159, 63, 0.1)",
        borderColor: "#2C9F3F",
        pointBackgroundColor: "#2C9F3F",
      };
    case "scheduledMaintenances":
    case "vehicleBreakdowns":
    case "quickService":
    case "idle":
      return {
        backgroundColor: "rgba(69, 128, 217, 0.1)",
        borderColor: "#4580D9",
        pointBackgroundColor: "#4580D9",
      };
    default:
      return {
        backgroundColor: "rgba(69, 128, 217, 0.1)",
        borderColor: "#4580D9",
        pointBackgroundColor: "#4580D9",
      };
  }
}

export default function TileSparkline(props: ComponentProps) {
  const { className, data } = props;
  
  // Handle empty or invalid data
  if (!data || !Array.isArray(data) || data.length === 0) {
    return <div className="emptyTileChart"></div>;
  }

  const colors = getColors(data[0]?.name);

  // Transform data for Chart.js format
  const chartData = {
    labels: data.map((item, index) => index.toString()), // or use actual x-axis labels if available
    datasets: [
      {
        data: data.map(item => item.y || item.value || 0), // Adjust based on your data structure
        fill: true,
        backgroundColor: colors.backgroundColor,
        borderColor: colors.borderColor,
        pointBackgroundColor: colors.pointBackgroundColor,
        pointBorderColor: colors.borderColor,
        pointRadius: 0, // Hide points for sparkline effect
        pointHoverRadius: 3,
        tension: 0.4, // Smooth curves
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false, // Disable tooltips for sparkline
      },
    },
    scales: {
      x: {
        display: false, // Hide x-axis
        grid: {
          display: false,
        },
      },
      y: {
        display: false, // Hide y-axis
        grid: {
          display: false,
        },
      },
    },
    elements: {
      point: {
        radius: 0, // Hide points
        hoverRadius: 0,
      },
    },
    interaction: {
      intersect: false,
      mode: 'index' as const,
    },
    layout: {
      padding: 0,
    },
  };

  return (
    <div className={className} style={{ width: '100%', height: '100%' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}